import React from 'react';
import { Button, useDisclosure } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import PrefillOfferModal from './PrefillOfferModal';
import useCreationFlowReport from '../../../hooks/useCreationFlowReport';
import { usePartyOffers } from '../../../../../../../parties/src/api/getPartyOffers';

const PrefillOfferButton: React.FC = () => {
  const { t } = useTranslation();
  const { data: advisoryReport } = useCreationFlowReport();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: partyOffers, isLoading: isLoadingPartyOffers } = usePartyOffers(
    advisoryReport?.party.id || '',
  );

  /** This can only be used inside Advisory Reports */
  if (!advisoryReport) return null;

  return (
    <>
      <PrefillOfferModal
        offers={partyOffers || []}
        isOpen={isOpen}
        onClose={onClose}
      />
      <Button
        size="sm"
        variant="white"
        isLoading={isLoadingPartyOffers}
        onClick={onOpen}
      >
        {t('ADVISORY-REPORTS_OFFER_MODAL_DETAIL_PREFILL-BUTTON')}
      </Button>
    </>
  );
};

export default PrefillOfferButton;
